import Button from 'components/buttons/Button';
import Comment from 'models/Comment';
import React from 'react';
import SingleComment from './SingleComment';

function CommentList({
    comments,
    handleLoadMore,
    hasNextPage
}: {
    comments: Comment[];
    handleLoadMore: () => void;
    hasNextPage: boolean;
}) {
    return (
        <div className="space-y-8 py-4">
            {comments.map((c) => (
                <SingleComment comment={c} key={c.id}></SingleComment>
            ))}

            {hasNextPage && (
                <div className="mt-4">
                    <Button variant="outlined" onClick={handleLoadMore}>
                        Prikaži več komentarjev
                    </Button>
                </div>
            )}
        </div>
    );
}

export default CommentList;
